import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalService, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-popup-header',
  templateUrl: './popup-header.component.html',
  styleUrls: ['./popup-header.component.scss']
})
export class PopupHeaderComponent implements OnInit {
  @Input() title: string = ''; @Input() top = 0; @Input() isTopPercentage = true; @Input() isPopup = true;
  @Output() onRefresh = new EventEmitter(); @Input() isRefresh = false;
  constructor(public localService: LocalService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.localService.onBlurPopupOpenedClosed(true);    
    if (!this.isPopup)
      this.localService.onSetNonPopup();
    if (this.top > 0)
      this.localService.onSetMarginTopForCurrentPopup(this.top, this.isTopPercentage);
  }

  onClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  ngOnDestroy(): void {
    this.localService.onBlurPopupOpenedClosed(false);
  }

  onRefreshTrigger() {
    this.onRefresh.emit();
  }
}
